import React, {ReactElement} from 'react'
import {PageMeta, TranslatedEntry} from '../../types'
import {CanonicalUrlLink} from './CanonicalUrlLink'
import {HrefLangLinks} from './HrefLangLinks'

type CanonicalTagsProps = {
  currentLocale: string
  meta: PageMeta
  slug: string
  translations?: TranslatedEntry[]
}

/**
 * Handles the canonical url link and also the hreflang links
 */
export const CanonicalTags = ({
  currentLocale,
  slug,
  meta,
  translations,
}: CanonicalTagsProps): ReactElement => (
  <>
    <CanonicalUrlLink meta={meta} slug={slug} />
    <HrefLangLinks currentLocale={currentLocale} meta={meta} translations={translations} />
  </>
)
